import { useTheme } from '../context/ThemeContext';

/**
 * Subtle i3 brand footer. Present on every authenticated page.
 *
 * Tiny navy/teal brand strip + mark + tagline + year — no more than one
 * line tall so it never competes with page content.
 */
export default function BrandFooter() {
  const { dark } = useTheme();
  return (
    <footer className="mt-16 border-t border-border/60 bg-background/60" data-testid="brand-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <img
              src={dark ? "/brand/i3-logo-reverse.svg" : "/brand/i3-logo-light.svg"}
              alt="i3 Radiology"
              className="h-6 w-auto object-contain"
            />
            <span
              className="text-[10px] italic"
              style={{ color: 'var(--i3-teal)', fontFamily: "'Museo Slab','Zilla Slab','Outfit',sans-serif", fontWeight: 300 }}
            >
              Infinity · Imaging · Interventions
            </span>
          </div>
          <div className="flex items-center gap-3 text-[10px] text-muted-foreground uppercase tracking-[0.14em]">
            <span>Radiology Assistant</span>
            <span className="w-1 h-1 rounded-full bg-muted-foreground/40" />
            <span>© {new Date().getFullYear()} i3 Radiology</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
